import { useForm, useFieldArray } from "react-hook-form";
import { screenScrollTo } from "js/utilities";

import BeneficiaryInfoCard from "./BeneficiaryInfoCard";
import { useTranslation } from "react-i18next";

export default function FACStepFour({ formStep, setFormStep, setFACFormData }) {
  const {
    register: FACStepFourRegister,
    handleSubmit: FACStepFourHandleSubmit,
    formState: { errors },
    control,
    setValue,
    clearErrors,
    setError,
    watch,
  } = useForm({
    defaultValues: {
      beneficiaries: [{}],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "beneficiaries",
  });

  const { t } = useTranslation();
  const onSubmit = (data) => {
    // screenScrollTo();
    setFormStep(5);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 4 && (
        <div>
          <hr />
          <p className="text-sm">{t("FACStep-four-title")}</p>

          <form onSubmit={FACStepFourHandleSubmit(onSubmit)}>
            {fields.map((beneficiaryField, index) => {
              return (
                <BeneficiaryInfoCard
                  key={beneficiaryField.id}
                  componentIndex={index}
                  lastComponent={fields.length - 1 === index}
                  FACStepFourRegister={FACStepFourRegister}
                  append={append}
                  remove={remove}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  control={control}
                  setError={setError}
                  watch={watch}
                />
              );
            })}

            <div className="flex justify-end">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                type="button"
                onClick={() => setFormStep(3)}
              >
                {t("FACStep-two-btn-1")}
              </button>

              <button className="ui-btn-primary ui-btn-min-w mt-4">
                {t("FACStep-two-btn-2")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
